<template>
	<input
		:type="type"
		v-model="model"
		:class="cn(
			'flex h-14 w-full rounded-2xl border-0 bg-muted px-4 text-base text-foreground placeholder:text-muted-foreground outline-none focus:ring-2 focus:ring-primary/30 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground disabled:cursor-not-allowed disabled:opacity-50',
			props.class
		)"
		v-bind="$attrs"
	>
</template>

<script setup lang="ts">
import { cn } from '../../../utils/cn';

const model = defineModel<string | number>({ default: '' });

const props = withDefaults(
	defineProps<{
		type?: string;
		class?: string;
	}>(),
	{
		type: 'text',
	},
);
</script>
